import { ReactNode } from 'react';
import Link from 'next/link';

import { ChevronRight } from 'lucide-react';
import { ListItem, ListItemLink, Separator } from './styles';
import { Typography } from '@mui/material';

interface BreadcrumbListItemProps {
  lastItem?: boolean;
  position: number;
  url: string;
  label: string;
  icon?: ReactNode;
}

export const BreadcrumbListItem = ({
  lastItem = false,
  position,
  url,
  label,
  icon,
}: BreadcrumbListItemProps) => {
  return (
    <>
      <ListItem
        itemProp="itemListElement"
        itemScope
        itemType="http://schema.org/ListItem"
      >
        <Link href={url} passHref prefetch={false} legacyBehavior>
          <ListItemLink rel={lastItem ? 'nofollow' : undefined} itemProp="item">
            {icon}
            <Typography
              color={lastItem ? 'textPrimary' : 'inherit'}
              itemProp="name"
              component="span"
            >
              {label}
            </Typography>
          </ListItemLink>
        </Link>

        <meta itemProp="position" content={`${position}`} />
      </ListItem>

      {!lastItem && (
        <Separator>
          <ChevronRight width={15} height={15} />
        </Separator>
      )}
    </>
  );
};
